/* joshhowattart.com — minimal interactions.
   Product gallery: thumbnail/stage viewer. Videos pause when hidden. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-item'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-thumb'));
    if (items.length < 2 || thumbs.length < 2) return;

    function pauseVideos() {
      items.forEach(function (item) {
        var video = item.querySelector('video');
        if (video && !video.paused) video.pause();
      });
    }

    function show(index) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      pauseVideos();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(index)) show(index);
      });
    });
  });
})();
